import { createFileRoute } from '@tanstack/react-router';

import { NewVideoType } from '@/pages/record-and-send/setup/new-video-type';

export const Route = createFileRoute('/_authenticated/_app/record-and-send/video-types/new')({
	component: NewVideoType,
});
